// CTSK-509 — "Notes" card on the document and work-item detail pages.
// Hidden entirely (and no notes request is fired) unless useNotesAccess says
// the feature is on: features resolved, enableNotes not off, notes:view held.

import { useState } from 'react';
import { useNotesAccess } from '../hooks/useNotesAccess.js';
import { CollapsiblePanel } from './CollapsiblePanel.js';
import { NotesSection } from './notes/NotesSection.js';

export interface NotesPanelProps {
  targetType: 'document' | 'workitem';
  targetId: string;
  onNavigate?: (path: string) => void;
}

export function NotesPanel({ targetType, targetId, onNavigate }: NotesPanelProps) {
  const access = useNotesAccess();
  const [count, setCount] = useState(0);
  if (!access.enabled) return null;
  return (
    <CollapsiblePanel
      storageKey={`notes:${targetType}`}
      title="Notes"
      badge={count > 0 ? `${count}` : undefined}
    >
      <NotesSection
        params={{ target: `${targetType}:${targetId}` }}
        access={access}
        target={{ targetType, targetId }}
        onNavigate={onNavigate}
        onCount={setCount}
      />
    </CollapsiblePanel>
  );
}
